import { Link } from "react-router-dom";
import { BrandMark } from "@/components/BrandMark";
import { Reveal } from "./Section";
import { EmailSetupButton, MailLine } from "./EmailCta";
import { IMG, goTo, CONTACT_EMAIL } from "./homeData";
import { SEO } from "@/seo/useSeo";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const CtaBand = ({ onStart }) => (
  <section className="relative overflow-hidden bg-[#0B1120] text-white" data-testid="home-cta">
    <div className="absolute inset-0 bg-cover bg-center opacity-40" style={{ backgroundImage: `url(${IMG.sydney})` }} />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0B1120] via-[#0B1120]/85 to-[#1E3A5F]/60" />
    <div className="h-2 home-hazard relative" />
    <Reveal className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-28">
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight max-w-3xl leading-[1.05]" data-testid="home-cta-title">Email us today. We&apos;ll get you signed up and running.</h2>
      <p className="mt-5 text-base md:text-lg text-slate-300 max-w-xl">Tell us a little about your company and crew and we&apos;ll set you up, invoices and all. Prefer to do it yourself? Start a free 30-day trial in a couple of minutes.</p>
      <div className="mt-9 flex flex-wrap gap-3">
        <EmailSetupButton testid="home-cta-email-btn" />
        <button onClick={onStart} data-testid="home-cta-start-btn" className="rounded-full border border-white/30 px-7 py-3.5 font-semibold hover:bg-white hover:text-[#0B1120] transition-colors">Start free trial</button>
      </div>
      <div className="mt-5"><MailLine testid="home-cta-mail" /></div>
    </Reveal>
  </section>
);

const COLS = [
  ["Product", [["Proof of work", () => goTo("proof")], ["Invoices", () => goTo("invoices")], ["Features", () => goTo("features")], ["Walkthroughs", () => goTo("walkthroughs")], ["Pricing", () => goTo("pricing")], ["FAQ", () => goTo("faq")]]],
  ["Solutions", [...SEO.site.nav, ...SEO.site.industries.map(([path]) => [path, SEO.pages[path].label])].map(([path, label]) => [label, path])],
  ["Guides", [["Supervisor guide (PDF)", "/Supervisor-Manual.pdf?v=2"], ["Worker guide (PDF)", "/Worker-Manual.pdf?v=2"]]],
  ["Company", [["Get in touch", () => goTo("contact")], ["Give feedback", () => goTo("feedback")], ["Privacy", `${BACKEND}/api/privacy`], ["Sign in", "/login"]]],
];
const cls = "text-sm text-slate-400 hover:text-white transition-colors";
const FootLink = ([label, to]) => {
  const id = `home-footer-${label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-+$/, "")}`;
  if (typeof to === "function") return <button key={label} onClick={to} className={cls} data-testid={id}>{label}</button>;
  if (to.startsWith("/") && !to.includes(".pdf")) return <Link key={label} to={to} className={cls} data-testid={id}>{label}</Link>;
  return <a key={label} href={to} target="_blank" rel="noreferrer" className={cls} data-testid={id}>{label}</a>;
};

export const HomeFooter = () => (
  <footer className="bg-[#070C17] text-white" data-testid="home-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid sm:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1fr_1fr] gap-10">
      <div>
        <BrandMark tone="light" />
        <p className="mt-4 text-sm text-slate-400 max-w-xs">The time sheet, payroll and proof of job app for Australian trade and service crews.</p>
        <a href={`mailto:${CONTACT_EMAIL}`} className="mt-4 inline-block text-sm font-semibold text-white hover:text-[#EA580C] transition-colors" data-testid="home-footer-email">{CONTACT_EMAIL}</a>
      </div>
      {COLS.map(([title, links]) => (
        <div key={title}>
          <p className="font-mono text-xs font-bold tracking-[0.2em] uppercase text-slate-500">{title}</p>
          <div className="mt-4 flex flex-col items-start gap-3">{links.map(FootLink)}</div>
        </div>
      ))}
    </div>
    <div className="border-t border-white/10">
      <p className="max-w-7xl mx-auto px-5 sm:px-8 py-6 text-xs text-slate-500">© 2026 Cross Jobs. Built for Australian trade and service crews.</p>
    </div>
  </footer>
);
